module.exports = __webpack_public_path__ + "static/media/icon-moduleE1.2403968e.png";